import { AlertCircle } from 'lucide-react';

// Compact inline amber banner placed near action buttons that are disabled
// because the user's email is not yet verified. The full-width
// EmailVerificationBanner at the top of the page handles the resend flow;
// this component simply names the reason so users understand why buttons
// are greyed out.
export function ActionGateBanner() {
  return (
    <div
      role="status"
      className="flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-800"
    >
      <AlertCircle className="h-4 w-4 shrink-0" />
      <span>
        Verify your email to perform this action. Use the banner above to resend the verification
        email.
      </span>
    </div>
  );
}
